import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { isAuthenticated, logoutUser, getUserId } from '../utils/auth';
import apiClient from '../api/apiClient';

const Navbar = () => {
  const [userData, setUserData] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        if (isAuthenticated()) {
          const userId = getUserId();
          const response = await apiClient.get(`/api/users/v1/${userId}`);
          const user_data = response.data;
          setUserData(user_data.data);
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
      }
    };

    fetchUserData();
  }, []);

  // Close mobile menu on route change
  useEffect(() => {
    setMobileOpen(false);
  }, [navigate]);

  const handleLogout = () => {
    setMobileOpen(false);
    logoutUser();
    navigate('/login');
  };

  const closeMobile = () => setMobileOpen(false);

  return (
    <>
      <nav className="navbar">
        <div className="navbar-brand">
          {isAuthenticated() ? (
            <Link to="/dashboard">Social Record News</Link>
          ) : (
            <Link to="/">Social Record News</Link>
          )}
        </div>

        {/* Mobile hamburger */}
        <button
          className="mobile-menu-btn"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          {mobileOpen ? '✕' : '☰'}
        </button>

        <div className={`navbar-links ${mobileOpen ? 'open' : ''}`}>
          {isAuthenticated() ? (
            <div className="user-nav-section">
              {userData && (
                <Link
                  to={`/api/users/v1/${userData.id}`}
                  className="user-profile-link"
                  onClick={closeMobile}
                >
                  👤 {userData.first_name}
                </Link>
              )}
              <Link to="/dashboard" onClick={closeMobile}>
                Dashboard
              </Link>
              <button onClick={handleLogout} className="logout-button">
                Sign Out
              </button>
            </div>
          ) : (
            <>
              <Link to="/" onClick={closeMobile}>Home</Link>
              <Link to="/about" onClick={closeMobile}>About</Link>
              <Link to="/contact" onClick={closeMobile}>Contact</Link>
              <Link to="/login" onClick={closeMobile} className="btn btn-primary btn-sm">
                Login
              </Link>
            </>
          )}
        </div>
      </nav>

      {/* Mobile overlay */}
      <div
        className={`mobile-overlay ${mobileOpen ? 'visible' : ''}`}
        onClick={closeMobile}
      />
    </>
  );
};

export default Navbar;
